// import { getPreferenceNameKey } from './index';

export const TERMS_CONDITION_DESC1 =
  "If you would like to sign up to receive electronic documents or notices, for any of the following options, please read the section titled 'Important Information' and the Statement(s) applicable to your communication preferences selection.";

export const TERMS_CONDITION_DESC2 = `Once you have read the 'Important Information' section and any of the below sections ("Statement(s)") that apply to your communication preferences selection and/or in which you have an interest, close this box, click the checkbox beside the Communication Preferences Terms & Conditions, and then click submit.`;

export const TERMS_CONDITION_LIST = [
  'Explanations of Benefits (EOB), Evidence of Payments (EOP), and Claim Delay Notices (Delay Notice) Notifications',
  'Savings Suggestion Notices',
  'Paperless Member Newsletters',
  'Member Health Statement Notices',
];

export const TERMS_CONDITION_TITLE2 = 'IMPORTANT INFORMATION';

export const TERMS_CONTENT =
  'The paperless process is complete only after successful notification of an electronic document and/or notice is delivered to the e-mail address and/or mobile phone number you provided, as applicable.';

export const TERMS_CONTENT2 =
  'To retrieve electronic documents, you must have: (1) access to the internet through a current browser; (2) an e-mail account or mobile phone; and (3) the Adobe Acrobat application to view the EOBs, EOPs, Delay Notices and any other document in PDF (you can obtain a free version of Adobe by clicking the Acrobat link on the Acrobat link on the claims page of this website).';

export const TERMS_CONTENT3 = `Please Note: To help ensure receipt of electronic documents, you may need to remove our e-mail notices from your anti-spam protection, if applicable. You must contact Member Services via your Secure Message Center or call the number on the back of your ID card if you have changed your e-mail address and/or your mobile phone number or you are unable to access or read your electronic documents. You can also change your e-mail address or mobile phone number by logging on to your health plan's website as a member and updating your contact information. Your paperless selection or electronic notices will end if an e-mail or Text (as defined below) delivery problem or a problem relating to your ability to access or read an electronic document cannot be resolved.`;

export const TERMS_CONTENT4 = `You have the right to receive paper copies, such as EOBs, EOPs, and Delay Notices, at any time without charge. You can sign up to receive paper by logging on to your health plan's website as a member and updating your contact information, then changing the checkmark from the desired selection in your communication preferences. You may also change your paperless option by calling the Member Service number on the back of your ID card. If your coverage is terminated or otherwise cancelled, you will receive notice of and have access to this website and your electronic documents for up to one year following the termination or cancellation date.`;

export const TERMS_CONDITION_TITLE3 =
  'STATEMENT REGARDING Paperless EOBs, EOPs AND DELAY NOTICES';
export const TERMS_CONTENT5 = `When you sign up to receive electronic documents you will be able to retrieve EOBs, and EOPs made directly to providers from your health savings account (HSA) pursuant to your prior authorization (if applicable) and Delay Notice from this website instead of receiving each in paper through the U.S. mail.`;
export const TERMS_CONTENT6 = `You can electronically receive EOB, EOP or Delay Notice notifications after receiving an e-mail at your provided e-mail address regarding the online posting of either document. Thereafter, you will log into this website using a username and password, click "View Claims" and provide a date range for the relevant claim. To access the EOB, EOP or Delay Notice, click to expand the claim row, then click either the "EOB" or "EOP," or "Delay Notice" link in the expanded claim row. This paperless option only applies to EOBs, EOPs and Delay Notices issued in connection with claims that are submitted after services have been rendered. All other EOBs and Delay Notices will continue to be furnished in paper through the U.S. mail. Delay Notices will be available online until they are no longer in process. Thereafter, the Delay Notice will be replaced by an EOB. Once EOBs and EOPs are posted online, they will be available until two years from the original date of service in the case of EOBs and payment in the case of EOPs for that particular claim (inclusive of any processing time). You have the right to request and obtain a paper version of an EOB, EOP or Delay Notice from Member Services at no charge, even after they are no longer available online. Contact the number on the back of your ID card to request a paper copy of an EOB, EOP or Delay Notice. You can also print these electronic documents from this website and / or save them to your computer.`;

export const TERMS_CONDITION_TITLE4 =
  'To sign up, subscribers must close this box, click the checkbox beside the Communication Preferences Terms & Conditions, and then click submit.';

export const TERMS_CONDITION_TITLE5 =
  'STATEMENT REGARDING SAVING SUGGESTIONS NOTICES';
export const TERMS_CONTENT7 =
  'You can electronically receive and retrieve Savings Suggestions. If you elect this option, you will receive an e-mail notification to login to this website and review potential Savings Suggestions regarding your health care. You can access your Savings Suggestions as soon as they are posted, and after receiving an e-mail at your provided e-mail address regarding the online posting of Savings Suggestions. Thereafter, you will log into this website using a username and password.To sign up, subscribers must close this box, click the checkbox beside the Communication Preferences Terms & Conditions, and then click submit. The election will apply to the individual making the election only, not to anyone else covered on the policy.';

export const TERMS_CONDITION_TITLE6 =
  'STATEMENT REGARDING Paperless MEMBER NEWSLETTERS';

export const TERMS_CONTENT8 = `You can electronically receive and retrieve Member Newsletters. In addition to other valuable information, Member Newsletters will include our annual notice of privacy practices (HIPAA and Gramm-Leach-Bliley Act) and our annual notice regarding the Women's Health and Cancer Rights Act (WHCRA). When you sign up for a paperless newsletter, you will receive monthly Member Newsletters at your provided e-mail address. You may also retrieve an electronic version of the Member Newsletter on your health plan's website by logging on as a member.`;

export const TERMS_CONTENT9 = `Please Note: If you personally chose not to receive a Member Newsletter, you can remove the restriction via the website or by calling the number at the back of your ID card; however, you cannot select a paperless delivery of Member Newsletters if your employer elected to decline delivery of our Member Newsletter.`;

export const TERMS_CONTENT10 = `You have the right to request and obtain a paper version of our Member Newsletter at no charge. These documents will be also available online for at least one year after they are produced. Contact the number on the back of your ID card to request a paper copy of a Member Newsletter. You can also print Member Newsletter topics at your convenience from the website.`;

export const TERMS_CONTENT11 = `Please Note: Initial paperless delivery of your Member Newsletter may be delayed for up to six weeks depending upon the date on which you signed up for the service. In the meantime, you will continue to receive a paper Member Newsletter. To sign up, subscribers must close this box, click the checkbox beside the Communication Preferences Terms & Conditions, and then click submit. This option will apply to the subscriber and his/her covered dependents and e-mail notices regarding each will be sent to the subscriber's personal e-mail address.`;

export const TERMS_CONDITION_TITLE7 =
  'STATEMENT REGARDING MEMBER HEALTH STATEMENT';
export const TERMS_CONTENT12 = `If you elect to receive an electronic notification that your Member Health Statement is ready for viewing, you will receive an e-mail or Text, as applicable, notifying you to login to this website and review your Member Health Statement. You may access your Member Health Statement as soon as they are posted, and after receiving an e-mail or Text, as applicable. You will receive an e-mail or Text quarterly.`;
export const TERMS_CONTENT13 = `To sign up, subscribers must close this box, click the checkbox beside the Communication Preferences Terms & Conditions, and then click submit. The election will apply to the individual making the election only, not to anyone else covered on the policy.`;

export const TERMS_CONDITION_TITLE8 = 'CONSENT TO RECEIVE ELECTRONIC DOCUMENTS';
export const TERMS_CONDITION_TITLE9 =
  'BY CLICKING "SUBMIT" AFTER CLICKING THE CHECKBOX BESIDE THE COMMUNICATION PREFERENCES TERMS AND CONDITIONS, YOU ARE CONFIRMING THE FOLLOWING:';

export const TERMS_CONDITION_LIST2 = [
  'I have read and understand the STATEMENT(S) REGARDING: paperless EOBs, EOPs and Delay Notices (Statement); Paperless Member Newsletters; and / or Saving Suggestion Notices set forth above;',
  'I consent to receiving such Electronic Documents as described above through this website in accordance with the Statement(s);',
  'I understand that I will no longer receive Notices in paper form, as applicable, unless (i) an e-mail delivery problem cannot be resolved, (ii) I elect to receive paper through this website or (iii) my coverage is terminated or cancelled; and',
  'I understand that EOPs relate to payments made from my own HSA and not from a group health plan sponsored by my employer or employee organization.',
];
export const TERMS_CONTENT14 = `Your health plan reserves the right to revise or otherwise update the terms and conditions of this Consent.`;

export const TERMS_CONDITION_HEADING =
  'Communication Preferences Terms and Conditions';

export const ACCEPT_BTN = 'Accept';
export const DECLINE_BTN = 'Decline';
export const SUCCESS = 'Success';
export const CLOSE = 'Close';
export const PREFERENCES_SAVED = 'Your preferences have been saved';
export const ONEXCHANGE_INFO =
  'Need to make changes? Please contact your marketplace exchange you used to signup for coverage.';
export const MEDICARE_INFO = 'Need to make changes? Please';
export const CMS_CONTACT_DESCRIPTION2 = 'contact customer service.';
export const PHONE_NUMBER_SAVED =
  'You are now subscribed to text messages. Standard messaging and data rates may apply.';

export const CONTACT_INFO_SAVED = 'Your contact information has been updated.';

export const EMAIL_ADDRESS_SAVED = 'Your email has been verified.';

export const CANCEL_BTN = 'Cancel';
export const ATTENTION = 'Attention';

export const API_FAILED_TITLE = 'Attention';
export const API_FAILED_CONTENT =
  "We're sorry, but an unexcepted error has occurred. Please try again.";
export const API_FAILED_CONTENTSECOND = 'Please try again';

export const PREFERENCE_SELECT_DESCRIPTION =
  'Please select which item you would like to edit.';

export const EMAIL_SELECT_DESCRIPTION =
  'To send you email communications, we’ll need to verify your email. Please enter it below.';

export const CUSTOMER_SUPPORT_TITLE = 'Oops!';
export const CUSTOMER_SUPPORT_DESCRIPTION =
  "Something went wrong, but we'd like to make it right. For further assistance, please call the number on the back of your ID card or send us a message via the Support page.";

export const EMAIL_BTN_TEXT = 'Email Address';
export const PHONE_BTN_TEXT = 'Phone Number';

export const FAILURE_CONTENT_DESELCT =
  'You have selected a non-electronic communication method. This will deselect your preference for paperless communication. Do you wish to proceed?';

/* Confirmation text Code */
export const EMAIL_CONFIRMATION_DESCRIPTION =
  'We will send a confirmation code to raquel323@gmail.com for verification.';
export const EMAIL_CONFIRMATION_SENDBTN = 'Send Code';
export const EMAIL_CONFIRMATION_DIFFBTN = 'Use a Different Email';
export const EMAIL_CONFIRMATION_CODE_DESCRIPTION =
  'We have sent a confirmation code to raquel323@gmail.com. Please enter it below.';

/* communication main page text */

export const BACK_TITLE = 'Back to Account Management';
export const TITLE = 'Communication Preferences';
export const HEADER_DESC =
  'You can set your communication preferences on this page, including paperless options.';
export const OPTION_TITLE =
  'Under “Go Paperless,” selecting the email option will set the preferences for all options listed below to email (except Health Coach). You can also select the opt-in to text messages option to receive helpful texts for various alerts and reminders related to your plan.';
export const OPTION_HEADER = 'Go Paperless';
export const OPTION1 = 'Send me emails where applicable.';
export const OPTION2 =
  'Opt-in to text messages for alerts, benefits information, care reminders, and more.';
export const PREFERENCE_TITLE =
  'You can also adjust your individual preferences for each type of communication here.';
export const CONDITION_HEADER = 'I have read and I accept:';
export const TERMS_CONDITION = 'Communication Preferences Terms & Conditions';
export const SAVE_BTN = 'Save Changes';
export const PHONE_SAVE_BTN = 'Save';
export const CONFIRM_EMAIL_BTN = 'Confirm Email';
export const ALERT_MODAL_TEXT =
  'This will deselect your preference for paperless communication. Would you like to proceed?';
export const VERIFY_CODE = 'Verify Code';
export const RESEND_CODE = 'Resend Code';

export const OK = 'OK';
export const YES = 'YES';
export const NO = 'NO';
export const TEMRS_URL = 'https://www.highmark.com/sms-texting/';
export const TEMRS_URL2 = 'https://member.allmyhealth.com/SMS.pdf';

export const MOBILE_PHONE_DESCRIPTION =
  'Please enter a valid mobile phone number to receive text messages. Standard messaging and data rates apply.';
export const WORK_PHONE_DESCRIPTION =
  'This contact method is unavailable because there is not a work phone number associated with this account. Please enter one below.';
export const HOME_PHONE_DESCRIPTION =
  'This contact method is unavailable because there is not a home phone number associated with this account. Please enter one below.';

/* Preference Text */

export const PREFERENCE_HEADER0 = 'Invoice';
export const PREFERENCE_SUBTITLE0 =
  'Notice when your invoice is ready to be paid.';
export const PREFERENCE_HEADER1 = 'Explanation of Benefits (EOB)';
export const PREFERENCE_SUBTITLE1 =
  'Notice of paid, denied, or delayed claims.';
export const PREFERENCE_HEADER2 = 'Insurance Plan Notices';
export const PREFERENCE_SUBTITLE2 =
  'Including: Coverage Agreement, Outline of Coverage, Endorsements, Amendatory Riders, Benefit Changes, Legal Notices, Benefit Booklet, Summary of Benefits and Coverage, Provider Information and other important reminders.';
export const PREFERENCE_HEADER3 = 'Health Statement';
export const PREFERENCE_SUBTITLE3 =
  'Notice when your Health Statement is ready for your review.';
export const PREFERENCE_HEADER4 = 'Wellness, Savings, and More';
export const PREFERENCE_SUBTITLE4 =
  // 'Health & Wellness benefits, and services available as part of your plan.';
  'Health & wellness benefits, programs, and services available as part of your plan.';
export const PREFERENCE_HEADER5 = 'Member Newsletter';
export const PREFERENCE_SUBTITLE5 =
  'Newsletters that discuss member benefits, programs, and discounts.';
export const PREFERENCE_HEADER6 = 'Health Coach';
export const PREFERENCE_SUBTITLE6 =
  // 'Health & Wellness benefits, and services available as part of your plan.';
  'Talk with a professional to help you better manage your health.';
export const PREFERENCE_HEADER7 = 'Other Products and Services';
export const PREFERENCE_SUBTITLE7 =
  'Vendor Discounts, programs, classes, and insurance coverage that is not a part of your plan.';

export const PREFERENCE_HEADER8 =
  'Authorization Determination Notice and Grievance & Appeals';

export const PREFERENCE_SUBTITLE8 =
  'Documentation of authorization notices, as well as filed grievances and appeals';

export const NEW_EMAIL_CONFIRM =
  'Please note that the new email address you verify will become the primary email address for your account.';

export const CONTINUE_DESCRIPTION = 'Do you wish to continue?';

export const RESEND_DESCRIPTION =
  'If you cannot locate the email with the code, please check your spam or junk folder.';

export const OPPS = 'Oops!';

/* Preference options */

export const PREFERENCE_OPTION1 = 'Personal Email';
export const PREFERENCE_OPTION2 = 'U.S. Mail';
export const PREFERENCE_OPTION3 = 'Do Not Contact';
export const PREFERENCE_OPTION4 = 'Home Phone';
export const PREFERENCE_OPTION5 = 'Mobile Phone';
export const PREFERENCE_OPTION6 = 'Work Phone';
export const PREFERENCE_OPTION7 = 'Text Message';
export const EDIT_TEXT = 'Edit Contact Information';

export const PREFERENCE_LABEL1 = 'Member Supplied Email';
export const PREFERENCE_LABEL2 = 'US Mail';
export const PREFERENCE_LABEL7 = 'Mobile Text';
export const PREFERENCE_LABEL3 = 'None';
export const PREFERENCE_LABEL4 = 'Home Phone';
export const PREFERENCE_LABEL5 = 'Mobile Phone';
export const PREFERENCE_LABEL6 = 'Work Phone';

export function getPreferenceLabel(str: string) {
  let result = '';
  if (str === 'Personal Email') result = PREFERENCE_LABEL1;
  else if (str === 'U.S. Mail') result = PREFERENCE_LABEL2;
  else if (str === 'Do Not Contact') result = PREFERENCE_LABEL3;
  else if (str === 'Home Phone') result = PREFERENCE_LABEL4;
  else if (str === 'Mobile Phone') result = PREFERENCE_LABEL5;
  else if (str === 'Work Phone') result = PREFERENCE_LABEL6;
  else result = PREFERENCE_LABEL7;
  return result;
}

export function getPreferenceNameKey(titleStr: string) {
  const str = decodeURIComponent(titleStr);
  let result = '';
  if (str === PREFERENCE_HEADER0) result = 'invoice';
  else if (str === PREFERENCE_HEADER1) result = 'eob';
  else if (str === PREFERENCE_HEADER2) result = 'insurance';
  else if (str === PREFERENCE_HEADER8) result = 'utilization';
  else if (str === PREFERENCE_HEADER3) result = 'healthStatement';
  else if (str === PREFERENCE_HEADER4) result = 'wellness';
  else if (str === PREFERENCE_HEADER5) result = 'memberNewslater';
  else if (str === PREFERENCE_HEADER6) result = 'healthCoach';
  else result = 'otherProducts';
  return result;
}
